import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { colors } from '../../maps/colors';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { useEffect } from 'react';
import Select from '@mui/material/Select';
import UploadProfileImageBox from "../uploadProfileImage/UploadProfileImageBox";
import useZibi from "../../zibi/UseZibi";
import { permissionsMap } from "../../maps/permissionsMap";
import styled from "styled-components";
import { Chip, FormGroup, Stack, Switch } from '@mui/material';

const ClientPriceStyled = styled.div`
  margin: 15px 0 10px;

  .client-price-label {
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
  }
`;
export default function AlertDialog(props) {
    let { open, onClose, product, onNewProduct, onRemove } = props;

    const [user] = useZibi('user');

    const userRole = user?.role?.[0];
    const permissions = permissionsMap[userRole];
    const isSuperAdmin = user.role.includes("SUPER_ADMIN");

    const productEdit = permissions.productEdit;
    const allowEditAll = productEdit.allow === 'all';
    const allowEditParts = productEdit.parts || [];

    const newProduct = !product;
    if (!product) product = {};

    const [imageBase64, setImageBase64] = useState(null);
    const [name, s_name] = useState(product.name || '');
    const [desc, s_desc] = useState(product.desc || '');
    const [aliases, s_aliases] = useState(product.aliases || []);
    const [barcode, s_barcode] = useState(product.barcode || '');
    const [new_alias, s_new_alias] = useState('');
    const [price, s_price] = useState(product.price || 0);
    const [numOfPixels, s_numOfPixels] = useState(product.numOfPixels || 0);
    const [pixelPerSquareRatio, s_pixelPerSquareRatio] = useState(product.pixelPerSquareRatio || 0);
    const [weight, s_weight] = useState(product.weight || 0);
    const [avgWeight, s_avgWeight] = useState(product.avgWeight || 0);
    const [type, s_type] = useState(product.type || 'SHELF');
    const [categoryId, s_categoryId] = useState(product.categoryId);
    const [hasAIModel, setHasAIModel] = useState(product.hasAIModel);
    const [categories, s_categories] = useState([]);
    const [placementShape, s_placementShape] = useState(product.placementShape || 'circle');
    const [placementDiameter, s_placementDiameter] = useState(product.placementDiameter || 4);
    const [deleteImage, setDeleteImage] = useState(false);

    let imageToShow = "";
    if (imageBase64) {
        imageToShow = imageBase64;
    } else if (product && product.imageUrl) {
        imageToShow = product.imageUrl;
    }
    if (deleteImage) {
        imageToShow = "";
    }

    const save = async () => {
        const apiCfg = {
            type: '',
            data: {
                imageBase64,
                name,
                desc,
                barcode,
                price,
                numOfPixels,
                pixelPerSquareRatio,
                weight,
                avgWeight,
                type,
                categoryId,
                hasAIModel,
                aliases,
                placementDiameter, 
                placementShape
            }
        };

        if (newProduct) {
            apiCfg.type = 'addProduct';
            apiCfg.data.categoryId = categoryId;
        } else {
            apiCfg.type = 'editProduct';
            apiCfg.data._id = product._id;
        }
        const response = await api(apiCfg);

        onNewProduct(response, !!newProduct);
        onClose();
    };

    const getCategories = async () => {
        const categories_res = await api({ type: 'getCategories' });
        s_categories(categories_res);
    };

    useEffect(() => {
        getCategories();
    }, []);

    const removeImageHandle = () => {
        setDeleteImage(true);
        setImageBase64(null);
    };

    const onImageSelect = (image) => {
        setImageBase64(image);
        setDeleteImage(false);
    };

    const deleteProductHandle = async () => {
        window.messageBox(`Are you sure delete ${product.name}?`, async (yesOrNo) => {
            if (yesOrNo) {
                await api({ type: 'removeProduct', data: { productId: product._id } });
                onRemove(product);
                onClose();
            }
        }, true);
    };

    const isDisabledPart = (keyName) => {
        let result = true;
        if (allowEditAll) {
            result = false;
        }

        if (result && allowEditParts?.length) {
            if (allowEditParts.indexOf(keyName) !== -1) {
                result = false;
            }
        }

        return result;
    };

    const handleDelete = (aliasToDelete) => () => {
        const index = aliases.indexOf(aliasToDelete);
        if (index === -1) return;
        aliases.splice(index, 1);
        s_aliases([...aliases])

    };

    const addAlias = (e) => {
        console.log('addAlias', new_alias)
        if (new_alias === '') return;
        aliases.push(new_alias);
        s_aliases([...aliases])
        s_new_alias('')
    };


    let clientPrice = null;
    if (product.clientProduct && userRole === 'SITE_ADMIN') {
        clientPrice = product.clientProduct?.data?.price || null;
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}

        >
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {newProduct ? <Tx>product.add.title</Tx> : <Tx>product.edit.title</Tx>}
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5 }}>
                    <UploadProfileImageBox
                        disabled={isDisabledPart('image')}
                        image={imageToShow}
                        onImageSelect={onImageSelect}
                        removeImageHandle={removeImageHandle}
                        disableCrop={true}
                    />

                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label"><Tx>product.type.type</Tx></FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            value={type}
                            onChange={e => s_type(e.target.value)}>
                            <FormControlLabel value="SHELF" control={
                                <Radio
                                    disabled={isDisabledPart('productType')}
                                />
                            }
                                label={<Tx>product.type.shelf</Tx>}
                            />
                            <FormControlLabel value="HANGER" control={
                                <Radio
                                    disabled={isDisabledPart('productType')}
                                />
                            }
                                label={<Tx>product.type.hanger</Tx>}
                            />
                        </RadioGroup>
                    </FormControl>

                    <Divider style={{ marginBottom: 10 }} />

                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"><Tx>product.category</Tx></InputLabel>
                        <Select
                            disabled={isDisabledPart('category')}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={categoryId}
                            label={<Tx>product.category</Tx>}
                            onChange={e => s_categoryId(e.target.value)}>
                            {
                                categories.map((cat, idx) => <MenuItem key={idx}
                                    value={cat._id}>{cat.name.toUpperCase()}</MenuItem>)
                            }

                        </Select>
                    </FormControl>

                    <Divider style={{ marginBottom: 10 }} />

                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                        <Grid item xs={6}>

                            <Text
                                disabled={isDisabledPart('name')}
                                label="product.form.name"
                                value={name}
                                onChange={s_name}
                                validators={['required']}
                                errorMessages={['this field is required']} />

                            <Text
                                disabled={isDisabledPart('description')}
                                label="product.form.description"
                                value={desc}
                                onChange={s_desc} />

                            <Divider style={{ marginBottom: 10 }} />

                            <Text
                                disabled={isDisabledPart('barcode')}
                                label="product.form.barcode"
                                value={barcode}
                                onChange={s_barcode}
                                validators={['required']}
                                errorMessages={['this field is required']} />


                            {clientPrice && (
                                <ClientPriceStyled>
                                    <span className="client-price-label">Client price:</span>
                                    <span>{clientPrice}</span>
                                </ClientPriceStyled>
                            )}

                            <Text
                                disabled={isDisabledPart('price')}
                                label="product.form.price"
                                type="number"
                                value={price}
                                onChange={s_price}
                                validators={['required']}
                                errorMessages={['this field is required']} />

                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <Text
                                    label="Add alias"
                                    value={new_alias}
                                    onChange={s_new_alias}
                                />

                                <Button
                                    style={{ width: '70px' }}
                                    onClick={addAlias}><Tx>Add</Tx></Button>
                            </div>


                            <Stack direction="row" style={{ marginBottom: '15px' }} spacing={1}>
                                {aliases.map((alias, index) => (
                                    <Chip key={index} label={alias} color="success" onDelete={handleDelete(alias)} />
                                ))}

                            </Stack>

                            {isSuperAdmin && (
                                <FormGroup>
                                    <Divider style={{ marginBottom: 10 }} />
                                    <div>Has AI model?</div>
                                    <FormControlLabel
                                        control={<Switch onChange={(e, nextValue) => setHasAIModel(nextValue)} checked={hasAIModel} />}

                                    />
                                </FormGroup>
                            )}
                        </Grid>
                        <Grid item xs={6}>
                            {
                                type === 'SHELF' && <>
                                    <Text
                                        disabled={isDisabledPart('numOfPixels')}
                                        label="product.form.numOfPixels"
                                        type="number"
                                        value={numOfPixels}
                                        onChange={s_numOfPixels}
                                        validators={['required']}
                                        errorMessages={['this field is required']} />

                                    <Text
                                        disabled={isDisabledPart('pixelPerSquareRatio')}
                                        label="product.form.pixelPerSquareRatio"
                                        type="number"
                                        value={pixelPerSquareRatio}
                                        onChange={s_pixelPerSquareRatio}
                                        validators={['required']}
                                        errorMessages={['this field is required']} />

                                    <Divider style={{ marginBottom: 10 }} />

                                    <Text
                                        disabled={isDisabledPart('avgWeight')}
                                        label="product.form.avgWeight"
                                        type="number"
                                        value={avgWeight}
                                        onChange={s_avgWeight}
                                        validators={['required']}
                                        errorMessages={['this field is required']} />

                                    <FormControl fullWidth style={{marginBottom: 10}}>
                                        <InputLabel id="placement-shape">Placement Shape</InputLabel>
                                        <Select
                                            disabled={isDisabledPart('category')}
                                            labelId="placement-shape"
                                            id="demo-simple-select"
                                            value={placementShape}
                                            label="Placement Shape"
                                            onChange={e => s_placementShape(e.target.value)}>
                                            {
                                                ["circle", "dash circle"].map((shape, idx) => <MenuItem key={idx}
                                                    value={shape}>{shape.toUpperCase()}</MenuItem>)
                                            }

                                        </Select>
                                    </FormControl>

                                    {
                                        ["circle", "dash circle"].includes(placementShape) && <Text
                                            label="Diameter (cm)"
                                            type="number"
                                            value={placementDiameter}
                                            onChange={s_placementDiameter}
                                            validators={['required']}
                                            errorMessages={['this field is required']} />
                                    }
                                </>
                            }
                            {
                                type === 'HANGER' && <>
                                    <Text
                                        disabled={isDisabledPart('weight')}
                                        label="product.form.weight"
                                        type="number"
                                        value={weight}
                                        onChange={s_weight}
                                        validators={['required']}
                                        errorMessages={['this field is required']} />
                                </>
                            }
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                    {!newProduct && (
                        <Button
                            disabled={isDisabledPart('delete')}
                            style={isDisabledPart('delete') ? {} : { color: colors.RED1 }}
                            onClick={deleteProductHandle}><Tx>product.delete</Tx></Button>
                    )}

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button
                        disabled={isDisabledPart('save')}
                        autoFocus type="submit">
                        <Tx>g.save</Tx>
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>);
}